import React, { useEffect, useState } from 'react';
import { readTable } from '../Panels/Add/PostgreSQLModal/tables';
import { toast } from 'react-toastify';
import './PostgreSQLTableModalContent.css';

export const PostgreSQLTableModalContent = ({
    host,
    port,
    database,
    user,
    password,
    table,
    setOverlay
}) => {
    const [tableContent, setTableContent] = useState(null);

    useEffect(() => {
        const fetchTableContent = async () => {
            if (setOverlay) {
                setOverlay({ active: true, message: `Dohvatanje podataka za tabelu ${table}...` });
            }

            const content = await readTable(host, port, database, user, password, table);

            if (setOverlay) {
                setOverlay({ active: false });
            }

            if (!content || !content.columns || !content.data) {
                toast.error("Došlo je do greške");
                return;
            }

            setTableContent(content);
        };

        fetchTableContent();
    }, [table]);

    return (
        <div className="table-modal-div">
            <table className="table-content-table">
                <thead>
                    <tr>
                        {tableContent?.columns?.map((col) => (
                            <th key={col.column_name}>{col.column_name}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {tableContent?.data?.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {tableContent.columns.map((col, colIndex) => (
                                <td key={colIndex}>{row[col.column_name] ?? '—'}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
